"use client";

import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
const products = [{
  id: "tallow",
  title: "Industrial Bovine & Sheep Tallow",
  description: "High-grade industrial tallow sourced from certified facilities, optimized for advanced biofuel production and oleochemical applications. Ensures high energy yield and consistent quality.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/industrial_tallow_processing.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/industrial_tallow_processing.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/industrial_tallow_processing.png-wvc-sizes",
  imageAlt: "Industrial tallow processing facility"
}, {
  id: "uco",
  title: "Used Cooking Oil (UCO)",
  description: "Sourced from regulated collection networks, our UCO is filtered and processed to meet strict ISCC standards for biodiesel and HVO feedstock, providing a sustainable second-life energy source.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/used_cooking_oil_storage.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/used_cooking_oil_storage.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/used_cooking_oil_storage.png-wvc-sizes",
  imageAlt: "Used cooking oil storage tanks"
}, {
  id: "plantbased",
  title: "Animal & Vegetable Acid Oil",
  description: "Industrial-grade animal and vegetable acid oil, suitable for biodiesel production, renewable fuel applications, and industrial processing across regional energy and manufacturing markets."
}, {
  id: "plantbasedoil",
  title: "Plant-Based Oil",
  description: "Plant-based feedstocks derived from vegetation specifically selected for biodiesel production and sustainable aviation fuel development."
}];
export default function TabbedProducts() {
  const [activeTab, setActiveTab] = useState('tallow');
  const product = products.find(p => p.id === activeTab) || products[0];
  return <section id="tabbedproducts" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
            Industrial Feedstocks
          </h2>
          <p className="text-muted-foreground text-lg">Reliable sourcing and logistics for high-quality biofuel feedstocks.</p>
        </div>

        <div className="grid grid-cols-2 md:flex md:flex-wrap justify-center gap-3 md:gap-8 mb-6 md:mb-8 border-b border-border">
          {products.map((p, i) => <Button key={p.id} data-index={i} variant="ghost" onClick={() => setActiveTab(p.id)} className={cn("rounded-lg border-2 px-3 py-2 md:px-4 md:py-6 text-xs md:text-sm font-bold uppercase tracking-widest transition-all hover:opacity-70 bg-muted/50 md:bg-transparent", activeTab === p.id ? "border-primary text-primary" : "border-transparent text-muted-foreground")}>
              {p.id === 'tallow' ? 'Tallow' : p.id === 'uco' ? 'UCO' : p.id === 'plantbasedoil' ? 'Plant-Based Oil' : 'Mixed Acid Oil'}
            </Button>)}
        </div>

        <Card className="border-border shadow-sm rounded-lg overflow-hidden bg-card">
          <div className="grid grid-cols-1 gap-0">
            
            <div className="p-6 md:p-10 flex flex-col justify-center items-center text-center">
              <h3 className="text-xl sm:text-2xl font-default font-bold text-foreground mb-4">
                {product.title}
              </h3>
              <p className="text-muted-foreground mb-8 leading-relaxed max-w-2xl mx-auto">
                {product.description}
              </p>

              <div className="mt-auto pt-4">
                <Button asChild size="lg" className="w-full sm:w-auto rounded-md">
                  <Link to="https://trusting-sunbird.10web.cloud/contact/">
                    Enquire Now <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}